import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const ArrowDown1Regular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='currentColor'
    stroke='currentColor'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M23.25 7.311 12.53 18.03a.749.749 0 0 1-1.06 0L.75 7.311'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
    />
  </svg>
)

export { ArrowDown1Regular }
